import { useLazyQuery, useQuery, useMutation } from "@apollo/client/react"; import React, { Fragment, useEffect, useMemo, useRef, useState } from 'react';

import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { FormControl, Grid, InputAdornment, InputLabel, ListItemIcon, MenuItem, Select, TextField, Tooltip } from '@mui/material';
import moment from 'moment';
import toast, { Toaster } from 'react-hot-toast';
import { PopoverModal } from '../../../components/popoverModal/PopoverModal';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { adaptDelegacionArray } from '../../../adapters/delegacionAdapter';
import { CustomChip } from '../../../components/chip/Chip';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { useNavigate } from 'react-router-dom';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { DateInput } from '../../../components/dateInput/DateInput';
import { GET_ALL_SOLICITUDES } from '../../../data/graphQL/queries/Traditum/getSolicitudes';
import { GET_DELEGACIONES_BY_USUARIO } from '../../../data/graphQL/queries/PacienteProbable/getAllDelegacionesByUsuario';
import { GET_USUARIO_DELEGACION_ORIGEN } from '../../../data/graphQL/queries/usuarios/getUsuarioDelegacionOrigen';
import { usePersistFilters } from '../../../hooks/usePersistFilters';
import './prorrogaContent.scss';
import { adaptTraditumEstadosArray, GET_ALL_ESTADOS } from '../../../data/graphQL/queries/Traditum/getAllEstados';
import { ACTUALIZAR_ESTADO_SOLICITUDES } from '../../../data/graphQL/mutations/Traditum/actualizarEstadoSolicitudes';
import { INGRESAR_SOLICITUDES_PENDIENTES } from '../../../data/graphQL/mutations/Traditum/ingresarSolicitudesPendientes';
import { VERIFICAR_SOLICITUDES_ENVIADAS } from '../../../data/graphQL/queries/Traditum/verificarSolicitudesEnviadas';
import { normalizeFilterValue } from '../../../helpers/tools';

export const TraditumContent = ({ setChildrenAction }) => {
  const navigate = useNavigate();
  const [datosOriginal, setDatosOriginal] = useState([]);
  const [solicitudes, setSolicitudes] = useState([]);
  const [delegaciones, setDelegaciones] = useState([]);
  const [estados, setEstados] = useState([]);
  const [delegacionOrigen, setDelegacionOrigen] = useState(0);
  const [solicitudesEnviadas, setSolicitudesEnviadas] = useState(0);

  const { filters, handleChangeFilters } = usePersistFilters({
    txtFiltro: '',
    fechaDesde: moment().add(-10, 'd').format("yyyy-MM-DD"),
    fechaHasta: moment().add(20, 'd').format("yyyy-MM-DD"),
    idDelegacion: delegacionOrigen,
    idEstado: 1
  }, "traditumFilters");

  const [estadosChip] = useState({
    1: { isYellow: true },
    2: { isYellow: true },
    3: { isYellow: true },
    4: { isRed: true },
    5: { isGreen: true },
    6: { isRed: true },
    7: { isRed: true },
    8: { isRed: true }
  });

  const storageId = sessionStorage.getItem('idUsuario');

  const handleClickEdit = (row) => {
    navigate('/contratos/crearContrato',
      {
        state: {
          idEvaluacion: row.idEvaluacion,
          idDelegacion: filters?.idDelegacion,
          delegacion: delegaciones?.find((x) => x.id === filters?.idDelegacion)?.displayName,
          origen: row.tipo,
          edit: false,
          nuevoPaciente: false,
          nuevoPacienteExistente: false,
          descEstadoEvaluacion: row.descEstadoEvaluacion
        }
      });
  };

  const handleView = (row) => {
    navigate('/traditum/detalleSolicitud',
      {
        state: {
          idEvaluacion: row.idEvaluacion,
          idDelegacion: filters?.idDelegacion,
          estados: estados,
          datosSolicitud: row
        }
      });
  };

  const initialColumns = [
    {
      headerName: '',
      field: 'action',
      minWidth: 40,
      width: 40,
      maxWidth: 40,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return <>
          <PopoverModal>
            <div className='popover-modal-content'>
              <div onClick={() => handleView(row)} aria-hidden='true'
                className='item-option clickable-option'>

                <VisibilityIcon className='edit-icon' />
                <span className='toggle-action'>Ver Solicitud</span>
              </div>
              <div onClick={() => handleClickEdit(row)} aria-hidden='true'
                className='item-option clickable-option'>

                <EditIcon className='edit-icon' />
                <span className='toggle-action'>Contrato</span>
              </div>
            </div>
          </PopoverModal>
        </>;
      }
    },
    {
      field: 'idSolicitud',
      headerName: '#',
      width: 70
    },
    {
      field: 'estado',
      headerName: 'Estado',
      width: 120,
      renderCell: ({ row }) => {
        const color = estadosChip[row?.idEstado];
        const estadoName = estados?.find((x) => x.id === row?.idEstado)?.displayName;
        return (
          <CustomChip
            label={estadoName}
            {...color} />);


      }
    },
    {
      field: 'idEvaluacion',
      headerName: 'Nro. Contrato',
      width: 100
    },
    {
      field: 'idPaciente',
      headerName: 'HC',
      width: 70
    },
    {
      field: 'paciente',
      headerName: 'Paciente',
      width: 200
    },
    {
      field: 'idPlanCuidado',
      headerName: 'ID Plan',
      width: 90
    },
    {
      field: 'planCuidado',
      headerName: 'Plan',
      width: 290
    },
    {
      field: 'numeroAfiliado',
      headerName: 'Nro de Afiliado',
      width: 130
    },
    {
      field: 'identificadorPrestadorPrescriptor',
      headerName: 'Prestador Prescriptor',
      width: 150
    },
    {
      field: 'codigoDiagnosticoTraditum',
      headerName: 'Cod. Diagnóstico',
      width: 130
    },
    {
      field: 'numeroTransaccion',
      headerName: 'Nro transacción',
      width: 130
    },
    {
      field: 'fechaPrescripcion',
      headerName: 'Fecha Prescripción',
      width: 150,
      type: 'date',
      limitDate: 2000
    }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns, true), [delegaciones, estados]);

  const { data: estadosData } = useQuery(GET_ALL_ESTADOS, {
    fetchPolicy: 'no-cache',
  });


  const [verificarSolicitudes, { data: solicitudesEnviadasData, loading: verificarSolicitudesLoading }] = useLazyQuery(VERIFICAR_SOLICITUDES_ENVIADAS, {
    fetchPolicy: 'no-cache'
  });

  const [getDelegaciones, { data: delegacionesData, loading: delegacionesLoading }] = useLazyQuery(GET_DELEGACIONES_BY_USUARIO, {
    fetchPolicy: 'no-cache'
  });
  const [getDelegacionOrigen, { data: delegacionOrigenData, loading: delegacionOrigenLoading }] = useLazyQuery(GET_USUARIO_DELEGACION_ORIGEN, {
    fetchPolicy: 'no-cache'
  });

  const [getSolicitudes, { data: solicitudesData, loading: solicitudesLoading }] = useLazyQuery(GET_ALL_SOLICITUDES, {
    fetchPolicy: 'no-cache',
  });

  const [actualizarEstados] = useMutation(ACTUALIZAR_ESTADO_SOLICITUDES);

  const [ingresarSolicitudesPendientes] = useMutation(INGRESAR_SOLICITUDES_PENDIENTES);

  useEffect(() => {
    if (!estadosData) return;

    setEstados(adaptTraditumEstadosArray(estadosData?.allTraditumEstado));
  }, [estadosData]);

  useEffect(() => {
    if (!solicitudesEnviadasData) return;

    setSolicitudesEnviadas(solicitudesEnviadasData?.verificarSolicitudesEnviadas?.valorEsperado);
  }, [solicitudesEnviadasData]);

  useEffect(() => {
    if (!delegacionesData) return;

    setDelegaciones(adaptDelegacionArray(delegacionesData));
  }, [delegacionesData]);

  useEffect(() => {
    if (!delegacionOrigenData?.usuarioFull?.success) return;

    const deleg = parseInt(delegacionOrigenData.usuarioFull.valorEsperado.delegacionOrigen, 10);
    sessionStorage.setItem('delegacionOrigen', deleg);
    setDelegacionOrigen(deleg);

    if (filters.idDelegacion == 0)
      handleChangeFilters('idDelegacion', deleg);
  }, [delegacionOrigenData]);

  useEffect(() => {
    if (!solicitudesData) return;
    setDatosOriginal(solicitudesData?.allSolicitudTraditum?.valorEsperado);
    setSolicitudes(solicitudesData?.allSolicitudTraditum?.valorEsperado);
  }, [solicitudesData]);

  useEffect(() => {
    if (!delegacionesLoading) {
      getDelegaciones({ variables: { idUsuario: JSON.parse(storageId) } });
    }
    getDelegacionOrigen({ variables: { idUsuario: JSON.parse(storageId) } });
    verificarSolicitudes();
  }, [storageId]);

  useEffect(() => {
    if (!solicitudesLoading && delegacionOrigen > 0) {
      getSolicitudes({
        variables: {
          input: {
            fechaDesde: filters?.fechaDesde,
            fechaHasta: filters?.fechaHasta,
            idDelegacion: filters?.idDelegacion,
            idEstado: !!filters?.idEstado ? filters?.idEstado : null
          }
        }
      });
    }
  }, [delegacionOrigen]);

  const handleChange = (e) => {
    const { value, name } = e.target;
    handleChangeFilters(name, value);
  };

  const handleClickIngresarPendientes = async () => {
    await verificarSolicitudes();

    if (solicitudesEnviadas > 0) {
      toast.error('Hay solicitudes Sujetas a Auditoria o con Error de Comprobacion que no tienen su correspondiente Numero de Transacción. Comuniquese con Sistemas para solucionarlo antes de lanzar el proceso nuevamente.');
    }

    await ingresarSolicitudesPendientes();
    getSolicitudes({
      variables: {
        input: {
          fechaDesde: filters?.fechaDesde,
          fechaHasta: filters?.fechaHasta,
          idDelegacion: filters?.idDelegacion,
          idEstado: !!filters?.idEstado ? filters?.idEstado : null
        }
      }
    });
  };

  const handleClickActualizarEstados = async () => {
    await verificarSolicitudes();

    if (solicitudesEnviadas > 0) {
      toast.error('Hay solicitudes Sujetas a Auditoria o con Error de Comprobacion que no tienen su correspondiente Numero de Transacción. Comuniquese con Sistemas para solucionarlo antes de lanzar el proceso nuevamente.');
    }

    await actualizarEstados();
    getSolicitudes({
      variables: {
        input: {
          fechaDesde: filters?.fechaDesde,
          fechaHasta: filters?.fechaHasta,
          idDelegacion: filters?.idDelegacion,
          idEstado: !!filters?.idEstado ? filters?.idEstado : null
        }
      }
    });
  };

  const handleChangeFechaDesde = (value) => {
    const nuevaFecha = value ? moment(value).format("yyyy-MM-DD") : "";
    handleChangeFilters("fechaDesde", nuevaFecha);
  };

  const handleChangeFechaHasta = (value) => {
    const nuevaFecha = value ? moment(value).format("yyyy-MM-DD") : "";
    handleChangeFilters("fechaHasta", nuevaFecha);
  };

  const handleSearch = () => {
    getSolicitudes({
      variables: {
        input: {
          fechaDesde: filters?.fechaDesde,
          fechaHasta: filters?.fechaHasta,
          idDelegacion: filters?.idDelegacion,
          idEstado: !!filters?.idEstado ? filters?.idEstado : null
        }
      }
    });
  };

  const buttonActionLoading = useMemo(() =>
    delegacionesLoading ||
    delegacionOrigenLoading ||
    verificarSolicitudesLoading ||
    solicitudesLoading,
    [
      delegacionesLoading,
      delegacionOrigenLoading,
      verificarSolicitudesLoading,
      solicitudesLoading]
  );

  const handleTextFilter = () => {
    const inputBuscar = normalizeFilterValue(filters?.txtFiltro);

    if (inputBuscar?.length >= 2) {
      setSolicitudes(datosOriginal?.filter((datoOriginal) => {
        const contratoBuscar = datoOriginal.idEvaluacion.toString();
        const idSolicitudbuscar = datoOriginal.idSolicitud.toString();
        const hCBuscar = datoOriginal.idPaciente.toString();
        const nombrePacienteBuscar = datoOriginal.paciente.toUpperCase();
        const planCuidado = datoOriginal.planCuidado ? datoOriginal.planCuidado.toUpperCase() : '';

        return (
          contratoBuscar.includes(inputBuscar) ||
          idSolicitudbuscar.includes(inputBuscar) ||
          planCuidado.includes(inputBuscar) ||
          nombrePacienteBuscar.includes(inputBuscar) ||
          hCBuscar.includes(inputBuscar));

      }));
    } else {
      setSolicitudes(datosOriginal);
    }
  };

  const handleTextClean = () => {
    handleChangeFilters('txtFiltro', '');
    setSolicitudes(datosOriginal);
  };

  useEffect(() => {
    setChildrenAction(() =>
      <div className='top-buttons'>
        <CustomButton
          className={'button-header'}
          variant={'outlined'}
          onClick={() => handleClickIngresarPendientes()}
          disabled={buttonActionLoading}>

          Ingresar Solicitudes Pendientes
        </CustomButton>
        <CustomButton
          className={'button-header'}
          onClick={() => handleClickActualizarEstados()}
          disabled={buttonActionLoading}>

          Actualizar Estado
        </CustomButton>
      </div>
    );
  }, [setChildrenAction, buttonActionLoading]);

  return (
    <>

      <div className='grid-container'>
        <Grid
          container
          spacing={2}
          sx={{ marginBottom: '25px' }}>

          <Grid size={{ xs: 12, md: 4, xl: 2.5 }}>
            <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
              <InputLabel id="select-delegacion">Delegación</InputLabel>
              <Select
                labelId="select-delegacion"
                options={delegaciones}
                label='Delegación'
                onChange={handleChange}
                value={filters?.idDelegacion}
                name='idDelegacion'>

                {delegaciones && delegaciones.map((delegacion) => {
                  return <MenuItem key={delegacion.id} value={delegacion.id}> {delegacion.displayName} </MenuItem>;
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, md: 4, xl: 2.5 }}>
            <TextField
              label="Filtrar"
              name="txtFiltro"
              size="small"
              type="text"
              fullWidth
              variant="outlined"
              value={filters?.txtFiltro}
              onChange={(e) => handleChangeFilters('txtFiltro', e.target.value)}
              onKeyUp={handleTextFilter}
              sx={{ backgroundColor: 'white' }}
              InputProps={{
                endAdornment:
                  <InputAdornment position="end">
                    <SearchIcon
                      onClick={handleTextFilter}
                      sx={{ cursor: 'pointer' }} />

                    <ClearIcon
                      onClick={handleTextClean}
                      sx={{ cursor: 'pointer' }} />

                  </InputAdornment>

              }} />

          </Grid>
          <Grid size={{ xs: 12, md: 4, xl: 2.5 }}>
            <FormControl
              fullWidth
              variant='outlined'
              size='small'>

              <InputLabel>{'Estado'}</InputLabel>
              <Select
                fullWidth
                variant='outlined'
                size='small'
                label='Estado'
                className='select-type-input'
                value={filters?.idEstado}
                onChange={(e) => { handleChangeFilters('idEstado', e.target.value); }}
                renderValue={() => { return estados?.find((option) => option.id === filters?.idEstado)?.displayName; }}>

                {estados?.map(({ id, displayName }, index) =>
                  <MenuItem
                    key={`${index}${displayName}`}
                    className='select-input-menu-item'
                    value={id}>

                    {displayName}
                  </MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, md: 4, xl: 1.8 }}>
            <DateInput
              label="Fecha Desde"
              value={filters?.fechaDesde}
              onChange={handleChangeFechaDesde} />

          </Grid>
          <Grid size={{ xs: 12, md: 4, xl: 1.8 }}>
            <DateInput
              label="Fecha Hasta"
              value={filters?.fechaHasta}
              onChange={handleChangeFechaHasta} />

          </Grid>
          <Grid sx={{ textAlign: 'right' }} size={{ xs: 12, md: 4, xl: 0.9 }}>
            <CustomButton
              variant='contained'
              className='margin-right'
              onClick={handleSearch}
              size='small'>

              Buscar
            </CustomButton>
          </Grid>
        </Grid>
        <DataGridGenerico
          columns={columns}
          rows={solicitudes}
          toolbar={false}
          loading={solicitudesLoading}
          maxWidth={columns.reduce((total, column) => total + (column.width || 0), 0)} />

      </div>
    </>);

};